import script from "./ArgonSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonSelect.vue?vue&type=script&setup=true&lang=js"

import "./ArgonSelect.vue?vue&type=style&index=0&id=b0203ab6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0203ab6"]])

export default __exports__